/** 判断当前是否处于已认证状态。 */
export function selectIsAuthenticated(state) {
    return state.session.status === 'authenticated';
}
/** 读取当前登录用户，未登录时为空。 */
export function selectSessionUser(state) {
    return state.session.user;
}
/** 判断登录弹窗是否展示。 */
export function selectIsAuthDialogOpen(state) {
    return state.session.isAuthDialogOpen;
}
/** 判断设置密码弹窗是否展示。 */
export function selectIsSetPasswordDialogOpen(state) {
    return state.session.isSetPasswordDialogOpen;
}
